import { Card, CardActionArea, Stack } from "@mui/material";
import { alpha, styled, useTheme } from "@mui/material/styles";
import { cloneElement, Fragment } from "react";

export default function MyCard(props) {
  const {
    link = "",
    img = <Fragment />,
    clientImg,
    onClick = () => {},
    target = "_blank",
    bgcolor = "primary.main",
    circleColorOne = "primary.main",
    circleColorTwo = "primary.main",
    size,
  } = props;

  const circleDiameter = 150; //210

  const styles = {
    imgStack: {
      height: "100%",
      ml: "-20px",
    },
    img: {
      width: size === "small" ? "100px" : size === "medium" ? "130px" : "170px",
    },
  };

  const CardWrapper = styled(Card)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    alignItems: "center",
    ml: "20px ",
    color: "#fff",
    //overflow: "hidden",
    position: "relative",
    minWidth: "320px",
    /*  "&:after": {
      content: '""',
      position: "absolute",
      width: circleDiameter,
      height: circleDiameter,
      background: circleColorOne,
      borderRadius: "50%",
      top: -85,
      right: -75,
      [theme.breakpoints.down("sm")]: {
        top: -105,
        right: -140,
      },
    },*/
    "&:before": {
      content: '""',
      position: "absolute",
      width: circleDiameter,
      height: circleDiameter,
      background: circleColorTwo,
      borderRadius: "50%",
      top: -110,
      right: -20,
      opacity: 1,
      [theme.breakpoints.down("sm")]: {
        top: -155,
        right: -70,
      },
    },
    "> .circle-three": {
      content: '""',
      position: "absolute",
      width: circleDiameter,
      height: circleDiameter,
      background: circleColorOne,
      borderRadius: "50%",
      top: -85,
      right: -75,
      [theme.breakpoints.down("sm")]: {
        top: -105,
        right: -140,
      },
    },
  }));
  const theme = useTheme();
  const customImg = cloneElement(img, {
    style: {
      width: size === "small" ? "100px" : size === "medium" ? "130px" : "170px",
      fill: theme.palette.text.primary,
    },
    //className: "custom-svg",
    role: "img",
  });
  return (
    <CardWrapper
      //elevation={1}
      //variant="elevation"
      sx={{
        borderRadius: 4,
        bgcolor: bgcolor,
        //minWidth: "355px",
      }}
    >
      <div className="circle-three" />
      <CardActionArea
        sx={{
          padding: "10px",
          height: "100px",
          "&:hover": { backgroundColor: theme.palette.background.hover },
        }}
        href={link}
        target={target}
        onClick={() => {
          onClick();
        }}
      >
        {clientImg ? (
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            sx={styles.imgStack}
          >
            <img src={clientImg} style={styles.img} />
          </Stack>
        ) : (
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            sx={styles.imgStack}
          >
            {customImg}
          </Stack>
        )}
      </CardActionArea>
    </CardWrapper>
  );
}
